<template>
  <div class="vx-card p-6">
    <h1 class="text-center mt-5">Garaj Yönetimi</h1>
    <form style="width: 100%;" class="pb-2 pt-2" @submit.prevent="getOrderList()">
      <!--1.row-->
      <div class="vx-row pl-0 pt-2">
        <div class="vx-col md:w-1/5 w-full">
          <label class="text-sm"><b>İşlem Id</b></label>
          <vs-input type="number" size="large" class="w-full" v-model="autoRefreshModel.id" />
        </div>
        <div class="vx-col md:w-1/5 w-full">
          <label class="text-sm"><b>Order Id</b></label>
          <vs-input type="number" size="large" class="w-full" v-model="autoRefreshModel.saleOrderId" />
        </div>
        <div class="vx-col md:w-1/5 w-full">
          <label class="text-sm"><b>Müşteri Id</b></label>
          <vs-input type="number" size="large" class="w-full" v-model="autoRefreshModel.customerId" />
        </div>
        <div class="vx-col md:w-1/5 w-full">
          <label class="text-sm"><b>Kaydı Giren Personel</b></label>
          <v-select @input="getOrderList()" placeholder="Seçiniz" label="userName" :options="personnelList" v-model="autoRefreshModel.createUserId" :reduce="(row) => row.userId">
            <span slot="no-options">Eşleşen Veri Yok</span>
          </v-select>
        </div>
        <div class="vx-col md:w-1/5 w-full mt-5">
          <b><vs-checkbox v-model="autoRefreshModel.isNotCompleted">Aktif</vs-checkbox></b>
        </div>
      </div>
      <!--2.row-->
      <div class="vx-row pl-0 pt-3">
        <div class="vx-col md:w-1/5 w-full">
          <label class="text-sm"><b>Durum</b></label>
          <v-select @input="getOrderList()" placeholder="Durum" label="value" :options="orderStatusList" v-model="autoRefreshModel.statusId" :reduce="(row) => row.id">
            <span slot="no-options">Eşleşen Veri Yok</span>
          </v-select>
        </div>

        <div class="vx-col md:w-1/5 w-full">
          <label class="text-sm"><b>Başlangıç</b></label>
          <vs-input type="date" size="medium" class="w-full" v-model="autoRefreshModel.startDate" />
        </div>
        <div class="vx-col md:w-1/5 w-full">
          <label class="text-sm"><b>Bitiş</b></label>
          <vs-input @change="getOrderList()" type="date" size="medium" class="w-full" v-model="autoRefreshModel.finishDate" />
        </div>
        <div class="vx-col md:w-1/5 w-full">
          <label class="text-sm"><b>Atanan Personel</b></label>
          <v-select @input="getOrderList()" placeholder="Seçiniz" label="userName" :options="personnelList" v-model="autoRefreshModel.assignedUserId" :reduce="(row) => row.userId">
            <span slot="no-options">Eşleşen Veri Yok</span>
          </v-select>
        </div>
        <div class="satis-buton w-full tFlex tFlex_column tFlex_ai-c mt-5">
          <vs-button class="vx-col md:w-1/4 w-full mb-4" style=""> Detaylı Ara</vs-button>
          <p class="text-center md:w-1/4 mb-4"></p>
          <vs-button class="vx-col md:w-1/4 w-full mb-4" @click.stop="showAddNew()">Garaj Kaydı</vs-button>
        </div>
      </div>
    </form>

    <vcl-facebook secondary="#ff9f43" v-if="loading"></vcl-facebook>
    <div v-if="!loading">
      <div id="technic-app" class="border border-solid d-theme-border-grey-light rounded relative overflow-hidden">
        <div class="app-fixed-height border border-r-0 border-b-0 border-t-0 border-solid d-theme-border-grey-light app-fixed-height">
          <div class="flex items-center app-search-container border border-l-0 border-r-0 border-t-0 border-solid d-theme-border-grey-light">
            <!-- TOGGLE SIDEBAR BUTTON -->
            <feather-icon class="md:inline-flex ml-4 mr-4 cursor-pointer" icon="MenuIcon" @click.stop="toggleSidebar()"></feather-icon>

            <!-- SEARCH BAR -->
            <vs-input size="large" icon-pack="feather" icon="icon-search" placeholder="Ara..." v-model="searchQuery" class="vs-input-no-border vs-input-no-shdow-focus no-icon-border w-3/4" />
            <div class="w-full sm:justify-end" style="display: contents;">
              <div class="flex items-center">
                <div @click="paginate(false)" class="material-icons cursor-pointer" style="transform: rotate(180deg);">
                  play_circle_outline
                </div>
                <input type="text" v-model="currentPage" @input="isNumeric" class="m-2" style="width: 40px;" />&nbsp;
                <span class="mx-2" style="white-space: nowrap;">/{{ calculatedPageCount }}</span>
                <div @click="paginate(true)" class="material-icons cursor-pointer">
                  play_circle_outline
                </div>
              </div>

              <div>
                <div class="vs-component con-vs-checkbox vs-checkbox-primary vs-checkbox-default">
                  <radial-progress-bar
                    :diameter="27"
                    v-if="progressBarCurrent < pageCount - 1"
                    :completed-steps="progressBarCurrent"
                    :strokeWidth="4"
                    :innerStrokeWidth="5"
                    :startColor="'#e41b1b'"
                    :stopColor="'#ff892e'"
                    :total-steps="pageCount - 1"
                  ></radial-progress-bar>
                </div>
              </div>
            </div>
          </div>

          <VuePerfectScrollbar class="technic-content-scroll-area" :settings="settings" ref="technicListPS">
            <transition-group class="technic-list" name="list-enter-up" tag="ul" appear>
              <li class="cursor-pointer technic_technic-item" v-for="(current, index) in currentPageData" :key="String(current.serviceId)" :style="[{ transitionDelay: index * 0.05 + 's' }]">
                <row-item
                  :serviceItem="current"
                  v-model="matchedField"
                  @showDisplayPrompt="showDisplayPrompt(current.serviceId)"
                  @openAssignPopup="showAssignedPopUpMenu(current.serviceId)"
                  @openAddMessagePopup="openAddMessagePopup(current.serviceId)"
                  @openTransferPopup="openTransferPopup(current.serviceId)"
                  @openInvoicePopup="openInvoicePopup(current.serviceId)"
                  ref="rowItemRef"
                ></row-item>
              </li>
              <div v-if="hasNoItems" :key="-1" class="px-4 py-4 list-item-component">
                <div class="center grid">
                  <vs-row style="margin: auto;">
                    <vs-col vs-type="flex" vs-justify="center" vs-align="center" w="12">
                      <h4>kayıt bulunamadı.</h4>
                    </vs-col>
                  </vs-row>
                </div>
              </div>
            </transition-group>
          </VuePerfectScrollbar>
        </div>

        <add-new :addnew="addNewRegister" v-if="addNewRegister" @hideAddNewRegister="hideAddNew" @addedData="sentDataAfteradd"></add-new>

        <garage-edit :displayPrompt="displayPrompt" :technicItemId="orderIdToEdit" @hideDisplayPrompt="hidePrompt" v-if="displayPrompt"></garage-edit>

        <!-- EDIT technic fastly -->
        <assign-popup :assignedPopUpMenu="assignedPopUpMenu" :serviceId="serviceId" :neighbourList="neighbours" @hideAssignedPopup="hideAssignedPopup" v-if="assignedPopUpMenu" @updateCompleted="assignUpdateCompleted"></assign-popup>

        <add-message-popup :serviceId="serviceId" v-if="addMessagePopupVisible" @updateCompleted="addMessagePopupVisible = false"></add-message-popup>

        <transfer-popup :serviceId="serviceId" v-if="transferPopupVisible" @updateCompleted="transferPopupVisible = false"></transfer-popup>

        <invoice-popup v-model="invoicePopupData" v-if="invoicePopupVisible" @updateCompleted="invoicePopupVisible = false"></invoice-popup>
      </div>
    </div>
  </div>
</template>

<script>
import AddNew from "./AddNew.vue";
import RowItem from "./RowItem.vue";
import Filters from "./Filters";
import GarageEdit from "./GarageEdit.vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import AssignPopup from "./AssignPopup.vue";
import AddMessagePopup from "./AddMessagePopup.vue";
import InvoicePopup from "./InvoicePopup.vue";
import TransferPopup from "./TransferPopup.vue";
import { repository } from "@/_services/repository.js";
import { VclFacebook } from "vue-content-loading";
import RadialProgressBar from "vue-radial-progress";
import vSelect from "vue-select";
export default {
  components: {
    AddNew,
    RowItem,
    Filters,
    GarageEdit,
    VuePerfectScrollbar,
    AssignPopup,
    AddMessagePopup,
    TransferPopup,
    VclFacebook,
    InvoicePopup,
    RadialProgressBar,
    vSelect,
  },
  data() {
    return {
      name: "Garage",
      personnelList: [],
      pageSize: 20,
      currentPage: 1,
      pageStr: "",
      autoRefresh: false,
      chkAutoRefreshDisabled: true,
      loading: true,
      orderStatusList: [],
      clickNotClose: true,
      displayPrompt: false,
      addNewRegister: false,
      assignedPopUpMenu: false,
      asignUpdateId: "",
      serviceId: 0,
      orderIdToEdit: 0,
      isSidebarActive: true,
      hasNoItems: false,
      windowWidth: window.innerWidth,
      addMessagePopupVisible: false,
      progressBarCurrent: 0,
      progressBarTotal: 0,
      transferPopupVisible: false,
      currentPageData: [],
      neighbours: [],
      matchedField: "",
      filteredItemCount: 0,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.3,
        suppressScrollX: true,
      },
      lastUpdated: new Date(),
      pageCount: 1,
      orders: null,
      FilterList: [],
      Filter: { filter1: "", filter2: "Garaj", filter3: "", expired: "" },
      LastFilter: {},
      searchQuery: "",
      autoRefreshModel: {
        id: 0,
        currentPage: 1,
        isNotCompleted: 1,
        serviceTypeName: "Garage",
      },
      lastAutoRefresh: new Date(),
      autoRefreshTimer: Number,
      autoRefreshSeconds: 10,
      invoicePopupVisible: false,
      invoicePopupData: Number,
    };
  },
  //notification pencerelerini açabilmek için
  //displayPromptIfNotification() adında bir method oluşturuyoruz.
  //watch ve computed eventlerini aşağıdaki gibi yazıyoruz.
  //item listemizi doldurduktan sonra this.displayPromptIfNotification(); methodumuzu çağırıyoruz.
  watch: {
    notification() {
      this.displayPromptIfNotification();
    },
    Filter: {
      handler: function () {
        this.currentPage = 1;
        this.renderItems();
      },
      deep: true,
    },
    currentPage: function () {
      this.renderItems();
    },
    searchQuery: function () {
      if (this.searchQuery.length > 3 || this.searchQuery.length == 0) {
        this.matchedField = { field: "NONE", value: "" };
        this.Filter.filter3 = this.searchQueryEn;
        this.createFilterList(this.Filter);
      }
    },
  },
  computed: {
    hasAnyActiveFilter() {
      return true;
    },
    actualPage() {
      return this.currentPage - 1;
    },
    calculatedPageCount() {
      return Math.ceil(this.filteredItemCount / this.pageSize);
    },
    searchQueryEn() {
      return repository.convertToEnglish(this.searchQuery.trim().toLowerCase());
    },
    filterQueryEn() {
      return repository.convertToEnglish(this.Filter.filter3.trim().toLowerCase());
    },
    notification() {
      return this.$store.state.notifications;
    },
    userData() {
      return this.$store.state.userData;
    },
  },
  methods: {
    handler() {
      this.currentPage = 1;
      this.renderItems();
    },
    isNumeric() {
      let c = parseInt(this.currentPage);
      if (isNaN(c)) c = 1;
      this.currentPage = c;
    },
    renderItems() {
      let currentPageData = [];
      this.currentPageData = [];
      if (!this.hasAnyActiveFilter) {
        this.filteredItemCount = this.FilterList.length;
        for (let i = 0; i < this.FilterList.length; i++) {
          this.FilterList[i].show = false;
          //herhangi bir filtre yok ise
          if (i >= this.pageSize * this.actualPage && i < this.pageSize * (this.actualPage + 1)) {
            this.FilterList[i].show = true;
            currentPageData.push(this.orders[i]);
          }
        }
        this.currentPageData = currentPageData;
        return;
      }
      let filteredItemCount = 0;
      for (let i = 0; i < this.FilterList.length; i++) {
        let filter = 0;
        let c = this.orders[i];
        if ((this.Filter.filter1.length > 0 && c.serviceStatus == this.Filter.filter1) || this.Filter.filter1.length == 0) {
          filter |= 1;
        }
        if ((this.Filter.filter2.length > 0 && c.serviceType == this.Filter.filter2) || this.Filter.filter2.length == 0) {
          filter |= 2;
        }
        if (this.Filter.filter3.length > 3) {
          if (this.handleFilters(c)) filter |= 4;
        } else {
          filter |= 4;
        }
        if (filter == 7) {
          this.FilterList[i].show = true;
          filteredItemCount++;
          if (currentPageData.length < this.pageSize) {
            if (filteredItemCount >= this.pageSize * this.actualPage && filteredItemCount < this.pageSize * (this.actualPage + 1)) currentPageData.push(this.orders[i]);
          }
        } else {
          this.FilterList[i].show = false;
        }
      }
      this.filteredItemCount = filteredItemCount;
      this.currentPageData = currentPageData;
    },
    handleFilters(i) {
      if (this.safeSearch(i.customerName)) {
        this.matchedField = {
          field: "customerName",
          value: this.Filter.filter3,
        };
        return true;
      } else if (this.safeSearch(i.customerPhone)) {
        this.matchedField = {
          field: "customerPhone",
          value: this.Filter.filter3,
        };
        return true;
      } else if (this.safeSearch(i.deliveredBY)) {
        this.matchedField = {
          field: "deliveredBY",
          value: this.Filter.filter3,
        };
        return true;
      } else if (this.safeSearch(i.assignedUser)) {
        this.matchedField = {
          field: "assignedUser",
          value: this.Filter.filter3,
        };
        return true;
      } else if (this.safeSearch(i.serviceId)) {
        this.matchedField = {
          field: "serviceId",
          value: this.Filter.filter3,
        };
        return true;
      } else if (this.safeSearch(this.convertToDateTime(i.createdDate))) {
        this.matchedField = {
          field: "createdDate",
          value: this.Filter.filter3,
        };
        return true;
      } else {
        if (i.products) {
          if (Array.isArray(i.products)) {
            for (var x = 0; x < i.products.length; x++) {
              if (this.safeSearch(i.products[x].productName)) {
                this.matchedField = {
                  field: "products",
                  value: this.Filter.filter3,
                };
                return true;
              }
            }
          } else {
            if (this.safeSearch(i.products.productName))
              this.matchedField = {
                field: "products",
                value: this.Filter.filter3,
              };
            return true;
          }
        } else return false;
      }
      return false;
    },
    paginate(d) {
      if (!this.orders || !Array.isArray(this.orders)) return;
      if (d) {
        if (this.pageSize * this.actualPage < this.filteredItemCount) {
          this.currentPage += 1;
        }
      } else {
        if (this.currentPage > 1) this.currentPage--;
      }
    },
    showAddNew() {
      this.addNewRegister = true;
    },
    assignUpdateCompleted(event, id, newStatus) {
      let status = JSON.parse(localStorage["technicstatusList"]).find((x) => x.id == newStatus).value;
      let so = this.orders.find((x) => x.serviceId == id);
      so.serviceStatus = status;
    },
    downloadRemainingPages: async function (currentPage, retries) {
      if (this.$route.name != this.name) return;
      if (!retries) retries = 0;
      if (currentPage < this.pageCount) {
        this.autoRefreshModel.currentPage++;
        let r = await repository.postEntity("technic/getOrdersFast", this.autoRefreshModel);
        if (r && r.list) {
          this.orders = this.orders.concat(r.list);
          this.beautifyOrderList();
          this.renderItems();
          this.progressBarCurrent = currentPage;
          setTimeout(this.downloadRemainingPages, 250, ++currentPage);
        } else {
          //veri çekilirken hata oluşursa tekrar çekmeye çalış
          if (retries < 5) setTimeout(this.downloadRemainingPages, 1000, currentPage, ++retries);
          else {
            this.$vs.notify({
              title: "Hata",
              text: "Bağlantı hatası",
              color: "danger",
            });
          }
        }
      } else {
        this.autoRefresh = true;
        this.getNewAndUpdated();
        let interval = setInterval(() => {
          this.getNewAndUpdated();
        }, 1000 * this.autoRefreshSeconds);
        repository.timers(interval, "technic_refresh", "int", true);
      }
    },
    getNewAndUpdated: async function () {
      let now = new Date();
      if (this.$route.name != this.name) return;
      this.lastAutoRefresh = now;
      this.autoRefreshModel.lastUpdated = this.lastUpdated;
      let r = await repository.postEntity("technic/getOrdersFast ", this.autoRefreshModel);
      if (r && r.lastUpdated) {
        let d1 = new Date(r.lastUpdated);
        let d2 = new Date(this.lastUpdated);
        if (d1 > d2) this.lastUpdated = r.lastUpdated;
      }
      if (r && r.list) {
        for (let i = 0; i < r.list.length; i++) {
          for (let j = this.orders.length - 1; j >= 0; j--) {
            if (this.orders[j].serviceId == r.list[i].serviceId) {
              this.orders.splice(j, 1);
              break;
            }
          }
        }
        for (let i = 0; i < r.list.length; i++) this.orders.unshift(r.list[i]);
        this.beautifyOrderList();
        this.renderItems();
      }
    },
    beautifyOrderList() {
      this.orders = repository.convertToJSON(this.orders, "products");
      this.FilterList = [];
      for (let i = 0; i < this.orders.length; i++) {
        this.FilterList.push({
          serviceId: this.orders[i].serviceId,
          show: true,
        });
      }
      this.filteredItemCount = this.FilterList.length;
      this.loading = false;
      this.displayPromptIfNotification();
    },

    getOrderList: async function () {
      this.$vs.loading();

      this.autoRefreshModel.lastUpdated = this.lastUpdated;

      let r = await repository.postEntity("technic/getOrdersFast ", this.autoRefreshModel);

      this.orders = r.list;
      this.lastUpdated = r.lastUpdated;
      this.pageCount = r.pageCount;
      this.progressBarCurrent = 1;

      this.$vs.loading.close();
      //setTimeout(this.downloadRemainingPages, 250, 1);
      this.beautifyOrderList();
      this.currentPageData = this.orders.slice(0, this.pageSize);
      this.renderItems();
      return this.orders;
    },
    getNeighbours: async function () {
      this.neighbours = await repository.postEntity("HumanResource/getUser", { teamId: this.$store.state.userData.teamId }).then((r) => r.list);
    },

    getUsers: async function () {
      this.personnelList = await repository.postEntity("HumanResource/getUser", {}).then((r) => r.list);
    },

    getOrderStatusList: async function () {
      let r = await repository.getAll("technic/getStatusList");
      if (!r) return;

      this.orderStatusList = r.list;
    },

    showDisplayPrompt(itemId) {
      itemId = parseInt(itemId);
      if (!isNaN(itemId)) {
        for (let i = 0; i < this.orders.length; i++) {
          if (itemId == this.orders[i].serviceId) {
            this.orderIdToEdit = itemId;
            this.displayPrompt = true;
            break;
          }
        }
      }
    },
    showAssignedPopUpMenu(itemId) {
      this.serviceId = itemId;
      this.assignedPopUpMenu = true;
    },
    openInvoicePopup(id) {
      this.invoicePopupData = id;
      this.invoicePopupVisible = true;
    },
    openAddMessagePopup(id) {
      this.serviceId = id;
      this.addMessagePopupVisible = true;
    },
    openTransferPopup(id) {
      this.serviceId = id;
      this.transferPopupVisible = true;
    },
    convertToDateTime(val) {
      if (val == null || !val) return "";
      let x = new Date(val);
      if (x == null || typeof x != "object" || !x) return "";
      return x.toLocaleDateString() + " " + x.toLocaleTimeString();
    },
    //arama ve filtrelere göre listeye show=(true yada false) yazar
    createFilterList(filter) {
      if (filter) {
        this.Filter.filter1 = filter.filter1;
        this.Filter.filter2 = "Garaj";
        this.Filter.expired = filter.expired;
      }
    },
    safeSearch(p1) {
      if (typeof p1 != "string") {
        p1 = JSON.stringify(p1);
      }
      p1 = (p1 && p1.toString().toLowerCase()) || "";
      let p2 = (this.Filter && this.Filter.filter3 && this.Filter.filter3.toString().toLowerCase()) || "";
      return p1.length > 0 && repository.convertToEnglish(p1).indexOf(p2) >= 0;
    },
    hideAssignedPopup() {
      this.assignedPopUpMenu = false;
    },

    hidePrompt() {
      this.displayPrompt = false;
    },
    //TODO: veriyi aldık unshift ile önceki verinin başınba eklenecek
    sentDataAfteradd(d) {
      this.orders.unshift(d);
      this.currentPageData.unshift(d);
      this.currentPageData.pop();
      setTimeout(() => {
        prompt("Servis kaydı başarıyla oluşturuldu", d.serviceId);
      }, 200);
    },
    hideAddNew() {
      this.addNewRegister = false;
    },
    handleWindowResize(event) {
      this.windowWidth = event.currentTarget.innerWidth;
      this.setSidebarWidth();
    },
    setSidebarWidth() {
      if (this.windowWidth < 992) {
        this.isSidebarActive = false;
      } else {
        this.isSidebarActive = true;
      }
    },
    // eslint-disable-next-line
    toggleSidebar(x = false) {
      //if (!x && this.clickNotClose) return;
      this.isSidebarActive = !this.isSidebarActive;
    },
    displayPromptIfNotification() {
      let x = this.notification;
      if (x != null && x.name == this.name && parseInt(x.id) > 0) {
        this.showDisplayPrompt(x.id);
        this.$store.commit("PUSH_NOTIFICATION_TO_COMPONENT", null);
      }
    },
  },
  created() {
    if (this.$route.params != null && this.$route.name == "GarageByCustomerId" && this.$route.params.customerId > 0) {
      this.autoRefreshModel.customerId = parseInt(this.$route.params.customerId);
      this.autoRefreshModel.isNotCompleted = 0;
    }
    Promise.all([this.getOrderList(), this.getNeighbours(), this.getOrderStatusList(), this.getUsers()]);

    this.$nextTick(() => {
      window.addEventListener("resize", this.handleWindowResize);
    });
    this.setSidebarWidth();
    if (this.$route.params != null && this.$route.name == "GarageById" && this.$route.params.serviceId > 0) {
      this.orderIdToEdit = parseInt(this.$route.params.serviceId);
      this.displayPrompt = true;
      this.hidePrompt = false;
    }
  },
  mounted() {
    document.addEventListener("keydown", (e) => {
      if (e.keyCode == 27) {
        if (this.displayPrompt) this.displayPrompt = false;
        else if (this.addNewRegister) this.addNewRegister = false;
        else if (this.assignedPopUpMenu) this.assignedPopUpMenu = false;
      }
    });
  },
  beforeDestroy: function () {
    window.removeEventListener("resize", this.handleWindowResize);
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/vuesax/apps/technic.scss";
.technic_technic-item:last-child .list-item-component {
  border-bottom: 1px solid #dae1e7;
}
</style>
